interface ChartLoadingStateProps {
  message?: string
}

export function ChartLoadingState({ message = 'Loading chart...' }: ChartLoadingStateProps) {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">
          {message}
        </p>
      </div>
    </div>
  )
}

interface ChartEmptyStateProps {
  message?: string
  icon?: string
}

export function ChartEmptyState({ 
  message = 'No data to display', 
  icon = '📊' 
}: ChartEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center">
      <div className="text-4xl mb-4">{icon}</div>
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
        No Data Available
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400">
        {message}
      </p>
    </div>
  )
}